
<div class="terminal">
    <span class="code" (click)="copyToClipboard(this.text)">
        <span class="copy"><img src="../../../../assets/icons/copy-text.svg" /></span>
        {{text}}
    </span>
</div>

